import React from 'react';
import LazyLoadImage from '../../shared/components/lazyload-image';

const defaultIntelBadge =
    '//www.hp.com/us-en/shop/app/assets/images/uploads/prod/11th-core-processor-3-family-badges-i5i7i3-rgb-30001604962083411773.png';
const defaultMessage = ['Intel® Core™ Processors. Intel Inside®.', 'Extraordinary Performance Outside.'];
const getIntelBadge = src => (typeof src === 'string' ? src : defaultIntelBadge);

export default ({ src, alt, customMessage = defaultMessage, className, textPosition = 'postfix' }) => {
    let customeMessageBlock = (
        <React.Fragment>
            {customMessage.map((m, i) => (
                <p key={i}>{m}</p>
            ))}
        </React.Fragment>
    );
    return (
        <div className={`badge-container${className ? ' ' + className : ''}`}>
            {textPosition === 'prefix' && customeMessageBlock}
            <LazyLoadImage src={getIntelBadge(src)} alt={alt} />
            {textPosition === 'postfix' && customeMessageBlock}
        </div>
    );
};
